import Main from './subPages/main';
import UsersRolesPage from './subPages/roles';
import UsersNotificationPages from './subPages/notifications';

const routes = [
  {
    path: '/users/*',
    canUse: [],
    Component: Main,
  },
  {
    path: '/user_roles/page/*',
    canUse: [],
    Component: UsersRolesPage,
  },
  {
    path: '/notification/page/*',
    canUse: [],
    Component: UsersNotificationPages,
  },
];

export default routes;
